import get from 'lodash.get'
import { createAction } from 'redux-actions'
import { resourcerPrivateParse } from 'utils/urlParser'
import { downloadFileByUrl } from 'utils/fileUtils'
import { SHOW_USER_FEEDBACK } from 'actions/types'
import * as types from './actionsTypes'
import { PendingTypeService } from './service'
import { getPayload, pendingSize } from './utils'

export const getAllPendings = (payload) => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  const page = payload.page || 1
  PendingTypeService.getAllPendings({ ...payload, size: pendingSize, page })
    .then(({ status, data }) => {
      if (status !== 200) return
      dispatch(createAction(types.GET_ALL_PENDINGS)({ data, page }))
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}
export const incrementCountOfUpdates = () => (dispatch) => {
  dispatch(createAction(types.INCREMENT_COUNT_OF_UPDATE)())
}

export const removePendingFromList = (id) => (dispatch, state) => {
  const pendings = get(state(), 'pendings.pendingsForModal', [])
  const newPendings = pendings.filter((item) => item.id !== id)
  dispatch(
    createAction(types.REMOVE_PENDINGS_FOR_LIST)({
      page: 1,
      data: newPendings,
    }),
  )
}
export const setPendingModal = (v) => (dispatch) =>
  dispatch(createAction(types.SET_PENDING_MODAL_VISIBLE)(v))

export const findPendencyById = (id, targetType) => (dispatch, state) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  const currentPendings = state().pendings.list
  PendingTypeService.findPendencyById(id, targetType)
    .then(({ status, data }) => {
      if (status === 200) {
        const newPendings = currentPendings.map(pending => {
          if (pending.id === id) {
            pending.viewed = true
            return pending
          }
          return pending
        })
        dispatch(createAction(types.GET_PENDING_BY_ID)(data))
        dispatch(createAction(types.LOCAL_UPDATE_LIST)(newPendings))
        return
      }
      dispatch(createAction(types.GET_PENDING_BY_ID)('Essa pendência não esta disponível ou foi removida.'))
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}
export const setPending = v => dispatch => dispatch(createAction(types.GET_PENDING_BY_ID)(v))

export const disablePendency = (payload, cb = () => {}) => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  const newPayload = getPayload()
  PendingTypeService.disablePendency(payload)
    .then(({ status, data }) => {
      if (status === 200) {
        cb()
        dispatch(getAllPendings({ ...newPayload, page: 1 }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}

export const resolvePendency = (payload, cb = () => {}) => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  const newPayload = getPayload()
  PendingTypeService.resolvePendency(payload)
    .then(({ status, data }) => {
      if (status === 200) {
        cb()
        dispatch(getAllPendings({ ...newPayload, page: 1 }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}
export const disablePendencyByModal = (payload, cb = () => {}, filter = {}) => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  PendingTypeService.disablePendency(payload)
    .then(({ status, data }) => {
      if (status === 200) {
        cb()
        dispatch(getAllPendings({ ...filter, page: 1 }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}

export const resolvePendencyByModal = (payload, cb = () => {}, filter = {}) => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  PendingTypeService.resolvePendency(payload)
    .then(({ status, data }) => {
      if (status === 200) {
        cb()
        dispatch(getAllPendings({ ...filter, page: 1 }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}

export const markAsUnviewed = (id) => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  const newPayload = getPayload()
  PendingTypeService.markAsUnviewed(id)
    .then(({ status }) => {
      if (status === 200) {
        dispatch(getAllPendings({ ...newPayload, page: 1 }))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}

export const fetchPendingIndicators = () => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  PendingTypeService.fetchPendingIndicators()
    .then(({ status, data }) => {
      if (status === 200) {
        dispatch(createAction(types.FETCH_PENDING_INDICATORS)(data))
      }
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}

export const getAllPendingTypes = () => (dispatch) => {
  dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(true))
  PendingTypeService.getAllPendingTypes()
    .then(({ status, data }) => {
      dispatch(createAction(types.GET_ALL_PENDING_TYPES)(data))
    })
    .catch((err) => console.log(err))
    .finally(() => dispatch(createAction(types.PENDING_IS_APPLICATION_LOADING)(false)))
}

export const generatePendingReport = (filters, setLoading) => dispatch => {
  dispatch(
    createAction(SHOW_USER_FEEDBACK)({
      feedbackMessage: 'O relatório está sendo processado',
      feedbackTitle: null,
      feedbackType: 'MESSAGE',
      styleFeedbackType: '',
      messageTimestamp: new Date().getTime(),
    }),
  )
  PendingTypeService.generateReport(filters).then(({ status, data }) => {
    if (status === 200 && data) {
      const url = resourcerPrivateParse(data)
      downloadFileByUrl(url)
      dispatch(
        createAction(SHOW_USER_FEEDBACK)({
          feedbackMessage: 'O relatório foi baixado com sucesso',
          feedbackTitle: null,
          feedbackType: 'MESSAGE',
          styleFeedbackType: 'success',
          messageTimestamp: new Date().getTime(),
        }),
      )
    }
  }).catch(err => console.log(err))
    .finally(() => setLoading(false))
}
